/* June offer: one same-size 1+1 mat bundle. Other products stay in the cart.
   THEME B ONLY (office/il-theme-b-2026-09-08/build2): every bundle also carries
   one free Nub ball as the promised "surprise gift" - variant 52904279900477,
   made 0 by the automatic Basic discount DiscountAutomaticNode/1262777761835
   (100% off that product, combines with the 1+1 BXGY). Mechanism restored from
   themes/mat-live-2026-09-03/assets/bp-cart.js (2026-09-02 origin, ops-notes.md
   ~8252-8264). The LIVE theme (theme A) keeps its own copy of this file WITHOUT
   this block - never port this gift logic there. Masking lives in
   snippets/cart-drawer.liquid and sections/main-cart-items.liquid ("(gift emoji)
   מתנת הפתעה", gift-tile image, no options, quantity locked). The gift rides
   with the bundle: added once per cart, re-added on self-heal if missing,
   dropped the moment no mat remains. */
(function () {
  'use strict';
  var BP = window.BarklyPaw = window.BarklyPaw || {};
  var MAT_PRODUCT = 10438284247357, GIFT_PRODUCT = 10476362137917, GIFT_VARIANT = 52904279900477, busy = false;
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  BP.money = function (cents) {
    return '₪' + (Number(cents) / 100).toLocaleString('he-IL', { maximumFractionDigits: 2 });
  };
  BP.flash = function (message) {
    var toast = document.createElement('div');
    toast.textContent = message;
    toast.setAttribute('role', 'status');
    toast.style.cssText = 'position:fixed;inset-inline:16px;bottom:90px;margin:auto;max-width:360px;background:#382e2e;color:white;padding:16px;border-radius:12px;text-align:center;font:700 16px Assistant,sans-serif;z-index:10000';
    document.body.appendChild(toast);
    setTimeout(function () { toast.remove(); }, 5500);
  };
  function isMat(item) { return Number(item.product_id) === MAT_PRODUCT; }
  function isGift(item) { return Number(item.product_id) === GIFT_PRODUCT; }
  function bundleItems(first, second) {
    return second && String(second) !== String(first)
      ? [{ id: Number(first), quantity: 1 }, { id: Number(second), quantity: 1 }]
      /* Same colour = two quantity-1 lines (hidden _bp_unit keeps them apart), so Meta's
         AddToCart browser and server values match. Totals unchanged (bp-cart.js, 2026-10-26). */
      : [{ id: Number(first), quantity: 1 }, { id: Number(first), quantity: 1, properties: { _bp_unit: '2' } }];
  }
  BP.bundleItems = bundleItems;
  async function request(path, body) {
    var response = await fetch(root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    var data = await response.json();
    if (!response.ok || (data.status && Number(data.status) >= 400)) throw new Error(data.description || 'Cart request failed');
    return data;
  }
  function sectionData() { return { sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }; }
  function render(data, open) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && data.sections && typeof drawer.renderContents === 'function') {
      try {
        drawer.classList.toggle('is-empty', data.item_count === 0);
        drawer.renderContents(data);
        if (open && typeof drawer.open === 'function') drawer.open();
        return;
      } catch (error) { /* A completed cart write must never be repeated. */ }
    }
    location.href = root + 'cart';
  }
  async function removeLines(cart, predicate) {
    var updates = {};
    cart.items.forEach(function (item) { if (predicate(item)) updates[item.key] = 0; });
    if (!Object.keys(updates).length) return cart;
    // Line keys handle Shopify's separate paid/free discount lines.
    return request('cart/update.js', Object.assign({ updates: updates }, sectionData()));
  }
  async function replaceBundle(cart, items) {
    var cleared = await removeLines(cart, function (item) { return isMat(item) || isGift(item); });
    if (cleared.items.some(isMat)) throw new Error('Existing bundle could not be replaced');
    /* The gift rides with the bundle as a unit: cleared above together with the
       mats, then re-added alongside them so it is never duplicated and never
       left behind once the mats are gone (items is [] when the bundle is being
       emptied entirely, so no gift is re-added). */
    var toAdd = items.length ? items.concat([{ id: GIFT_VARIANT, quantity: 1 }]) : items;
    return toAdd.length ? request('cart/add.js', Object.assign({ items: toAdd }, sectionData())) : cleared;
  }
  BP.addBundle = async function (first, button, second) {
    if (!first) { BP.flash('בחרו צבע ומידה לפני ההוספה לעגלה'); return; }
    if (busy) return;
    busy = true;
    if (button) { button.disabled = true; button.classList.add('bp-loading'); }
    try {
      var cart = await request('cart.js');
      var result = await replaceBundle(cart, bundleItems(first, second));
      render(result, true);
    } catch (error) {
      BP.flash('לא הצלחנו לאשר את העדכון. בדקו את העגלה לפני ניסיון נוסף.');
    } finally {
      busy = false;
      if (button) { button.disabled = false; button.classList.remove('bp-loading'); }
    }
  };
  function initRemove() {
    document.addEventListener('click', async function (event) {
      var button = event.target.closest('cart-remove-button, .cart-remove-button');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      busy = true;
      try {
        var indexNode = button.closest('[data-index]');
        var index = Number(button.dataset.index || (indexNode && indexNode.dataset.index));
        var cart = await request('cart.js');
        var selected = cart.items[index - 1];
        if (!selected) throw new Error('Cart line changed');
        var result = await removeLines(cart, function (item) {
          return isMat(selected) ? isMat(item) || isGift(item) : item.key === selected.key;
        });
        if (location.pathname === root + 'cart') location.reload();
        else render(result, true);
      } catch (error) { BP.flash('לא הצלחנו לאשר את ההסרה. רעננו את העגלה ונסו שוב.'); }
      finally { busy = false; }
    }, true);
  }
  // Repair old multi-bundle carts, preserving the first complete same-size pair.
  // Also self-heals the gift: added when a healthy bundle exists without one
  // (e.g. it predates this mechanism), dropped if it is ever left riding alone
  // with no mat left in the cart.
  async function enforceBundleCeiling() {
    if (busy) return;
    busy = true;
    try {
      var cart = await request('cart.js'), mats = cart.items.filter(isMat), groups = {};
      var count = mats.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      mats.forEach(function (item) {
        var match = String(item.variant_title || item.title).match(/\b(XS|XL|S|M|L)\b/);
        var size = match ? match[1] : 'unknown';
        groups[size] = groups[size] || [];
        for (var i = 0; i < item.quantity; i++) groups[size].push(item.variant_id);
      });
      var sizes = Object.keys(groups), result;
      var invalid = count > 0 && (count !== 2 || sizes.length !== 1 || sizes[0] === 'unknown');
      var hasGift = cart.items.some(isGift);
      if (invalid) {
        var pairSize = sizes.find(function (size) { return size !== 'unknown' && groups[size].length >= 2; });
        result = await replaceBundle(cart, pairSize ? bundleItems(groups[pairSize][0], groups[pairSize][1]) : []);
      } else if (count > 0 && !hasGift) {
        result = await request('cart/add.js', Object.assign({ items: [{ id: GIFT_VARIANT, quantity: 1 }] }, sectionData()));
      } else if (count === 0 && hasGift) {
        result = await removeLines(cart, isGift);
      }
      if (result) location.reload();
    } catch (error) { /* Leave an unavailable cart untouched. */ }
    finally { busy = false; }
  }
  BP.enforceBundleCeiling = enforceBundleCeiling;
  BP.restartCartTimer = function () {};
  function boot() {
    initRemove();
    var bar = document.querySelector('[data-bp-sticky]'), mainButton = document.querySelector('[data-bp-hero-atc]');
    if (bar && mainButton) {
      document.body.classList.add('bp-has-sticky');
      function sticky() { bar.classList.toggle('is-on', mainButton.getBoundingClientRect().bottom < 0); }
      window.addEventListener('scroll', sticky, { passive: true });
      sticky();
    }
    document.querySelectorAll('[data-bp-eta]').forEach(function (node) { node.textContent = 'משלוח חינם · 8–16 ימי עסקים'; });
    enforceBundleCeiling();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
